"use client";
import { useState, useSyncExternalStore } from "react";

const storageKey = "mira.login-phone.v1";
const changeEvent = "mira:login-phone-change";
let currentPhone: string | undefined;
const validPhone = (value: string) => /^1[3-9]\d{9}$/u.test(value);

export function rememberedPhone() {
  if (typeof window === "undefined") return "";
  if (currentPhone !== undefined) return currentPhone;
  try {
    const stored = window.localStorage.getItem(storageKey) ?? "";
    currentPhone = validPhone(stored) ? stored : "";
  } catch { currentPhone = ""; }
  return currentPhone;
}

export function rememberPhone(value: string) {
  if (typeof window === "undefined") return;
  currentPhone = value.replace(/\D/gu, "").slice(0, 11);
  try {
    if (validPhone(currentPhone)) window.localStorage.setItem(storageKey, currentPhone);
    else window.localStorage.removeItem(storageKey);
  } catch { /* Storage can be unavailable; the form still works in memory. */ }
  window.dispatchEvent(new Event(changeEvent));
}

function subscribe(callback: () => void) {
  window.addEventListener(changeEvent, callback);
  return () => window.removeEventListener(changeEvent, callback);
}
const empty = () => "";
const noSubscription = () => () => {};

export function useRememberedPhone(enabled = true) {
  // SSR never reads browser storage. Only this tab's forms synchronize changes;
  // a different tab must not silently change a pending SMS challenge's phone.
  const remembered = useSyncExternalStore(enabled ? subscribe : noSubscription, enabled ? rememberedPhone : empty, empty);
  const [local, setLocal] = useState("");
  return enabled ? [remembered, rememberPhone] as const : [local, setLocal] as const;
}
